import { useEffect } from "react";
import Footer from "Components/Common/Footer/Footer";
import HeaderWithoutMenu from "Components/Common/Header/HeaderWithoutMenu";
import UserDetailsBody from "Components/Common/UserDetails/UserDetailsBody/UserDetailsBody";

const UserDetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeaderWithoutMenu />
      <UserDetailsBody />
      <Footer />
    </>
  );
};

export default UserDetails;
